import React, { useState } from 'react';
import CisList from './CisList';
import LoadSimple from '../LoadSimple';
import Modal from 'react-modal';
import ModalDeleteCis from "./ModalDeleteCis";
import ModalReqAuth from './ModalReqAuth';
import { lang } from '../generales/traduction';
import { capitalizeFirstLetter } from '../../utils/utils';
import InternalError from "../generales/InternalError";
import Instalaciones from './Instalaciones';
import CredentialsSSH from './CredentialsSSH';
import Actualizaciones from './Actualizaciones';
import InstalacionesPrinters from './InstalacionesPrinters';
import OperativeSistem from './OperativeSistem';
import './styles/provicionamiento.css'
const deleteCisModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const deleteBuzonModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'40%',
    height:'30%',
    padding:'20px'
  },
};
const TableCisConfig = ({
  buscar_cis_history,
  handleChangEdit,
  cisSelected,
  server,
  handleShowPopup,
  languaje,
  mode
}) => {
  const [listSelected, setListSelected] = useState(1);
  const [internalError,setInternalError]=useState(false)
  const hadleChangeList = (e) => {
    setListSelected(e);
  };
  function renderAdminComponent() {
    // console.log('Main monitor '+pageSelected)
    try {
        switch (listSelected) {
            case 1:
                return <Instalaciones
                      mode={mode}
                      handleShowPopup={handleShowPopup}
                      server={server}
                      cisSelected={cisSelected}
                      languaje={languaje}
                    />
                ;
                case 2:
                  return <Actualizaciones
                            mode={mode}
                            handleShowPopup={handleShowPopup}
                            server={server}
                            title='work station'
                            cisSelected={cisSelected}
                            languaje={languaje}
                          />
                      ;
            case 3:
                return <CredentialsSSH
                          mode={mode}
                          handleShowPopup={handleShowPopup}
                          server={server}
                          title='work station'
                          cisSelected={cisSelected}
                          languaje={languaje}
                        />
                    ;
            case 4:
                      return <InstalacionesPrinters
                                mode={mode}
                                handleShowPopup={handleShowPopup}
                                server={server}
                                title='work station'
                                cisSelected={cisSelected}
                                languaje={languaje}
                              />
                          ;
            case 5:
                            return <OperativeSistem
                                      mode={mode}
                                      handleShowPopup={handleShowPopup}
                                      server={server}
                                      title='work station'
                                      cisSelected={cisSelected}
                                      languaje={languaje}
                                    />
                                ;
            //         case 3:
            //             return <Printers
            //                       mode={mode}
            //                       handleShowPopup={handleShowPopup}
            //                       server={server}
            //                       title='Printer'
            //                       languaje={languaje}
            //                     />
            //                 ;
                             default:
                return <></>;
        }
    } catch (error) {
        console.error('Error rendering component:', error);
        return <div>{lang[languaje['msgErrorPagina']]}</div>;
    }
}
  return (
    <>
    <div className='menu-monitor prov-menu'>
                     <ol className='compact-menu-list-monitor menu-list-prov' style={{justifyContent:'start'}}>
                        <li className={listSelected===1?'list-selected':''} onClick={() =>hadleChangeList(1)}>{capitalizeFirstLetter(lang[languaje]['provicionamientoDesmantelamiento'])}</li>
                        <li className={listSelected===2?'list-selected':''} onClick={() =>hadleChangeList(2)}>{capitalizeFirstLetter(lang[languaje]['actualizaciones'])}</li>
                        <li className={listSelected===3?'list-selected':''} onClick={() =>hadleChangeList(3)}>{capitalizeFirstLetter(lang[languaje]['configuracionCredenciales'])}</li>
                        <li className={listSelected===4?'list-selected':''} onClick={() =>hadleChangeList(4)}>{capitalizeFirstLetter(lang[languaje]['impresoras'])}</li>
                        <li className={listSelected===5?'list-selected':''} onClick={() =>hadleChangeList(5)}>{capitalizeFirstLetter(lang[languaje]['sistemasOperativos'])}</li>
                    </ol>
                    <hr className='head-line-monitor'></hr>
                </div>
    <div className='cont-table-portafolio' style={{height:'90%'}}>
    {(internalError)?
            <InternalError/>
            :renderAdminComponent()}
                                </div>
                                </>
  );
}

export default TableCisConfig;
